module.exports = __webpack_public_path__ + "static/img/icon_girl.10b6924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon_girl.png
// module id = b0Zd
// module chunks = 96